import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Module-level cache so multiple components on the same page don't refetch.
let cachedSettings = null;
let inflight = null;

function fetchSettings() {
  if (cachedSettings) return Promise.resolve(cachedSettings);
  if (inflight) return inflight;
  inflight = axios
    .get(`${API}/site-settings`)
    .then((res) => {
      cachedSettings = res.data || {};
      return cachedSettings;
    })
    .catch(() => ({}))
    .finally(() => {
      inflight = null;
    });
  return inflight;
}

/**
 * Shared read-only hook that returns the current site_settings document.
 * All homepage sections and the Contact page use this to hydrate their copy
 * from the CMS. Returns `null` while loading so callers can render defaults
 * without a flash of empty content.
 */
export function useSiteSettings() {
  const [settings, setSettings] = useState(cachedSettings);

  useEffect(() => {
    let alive = true;
    if (cachedSettings) {
      setSettings(cachedSettings);
      return () => {
        alive = false;
      };
    }
    fetchSettings().then((data) => {
      if (alive) setSettings(data);
    });
    return () => {
      alive = false;
    };
  }, []);

  return settings;
}
